import {
  faro,
  getWebInstrumentations,
  initializeFaro,
} from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

const host = window.location.host;

const ENV = {
  isLocal: host.includes('local'),
  isStaging: host.includes('staging.'),
};

const CONFIG = {
  url: ENV.isStaging
    ? 'https://faro-collector-prod-us-east-2.grafana.net/collect/b0155ce333ca58796639fc495edfab7e'
    : 'https://faro-collector-prod-us-east-2.grafana.net/collect/ae07bc32ed25150f7459edfe83aa6483',
  appName: ENV.isStaging
    ? 'Highway-Onboarding-Staging'
    : 'Highway-Onboarding-prod',
};

let initialized = false;
let pendingUser = null;

export function initializeGrafanaFaro() {
  if (ENV.isLocal || initialized) return;

  initializeFaro({
    url: CONFIG.url,
    app: {
      name: CONFIG.appName,
      version: process.env.VERSION,
      environment: process.env.NODE_ENV,
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation(),
    ],
  });

  initialized = true;

  // Set pending user if setGrafanaFaroUser was called before initialization
  if (pendingUser) {
    setGrafanaFaroUser(pendingUser);
    pendingUser = null;
  }
}

export function initializeGrafanaFaroIfEnabled(featureFlags) {
  if (ENV.isLocal) return false;

  if (featureFlags?.enable_grafana_faro_onboarding?.enabled && !initialized) {
    initializeGrafanaFaro();
    return true;
  }
  return false;
}

export function setGrafanaFaroUser(user) {
  if (!user) return;

  // If Faro isn't initialized yet, store user to set after initialization
  if (!initialized) {
    pendingUser = user;
    return;
  }

  const userId = user.id?.toString();

  faro.api.setUser({
    id: userId,
    email: user.email,
    username:
      user.full_name ||
      `${user.first_name || ''} ${user.last_name || ''}`.trim(),
    attributes: {
      companyId: user.company?.id?.toString(),
      companyName: user.company?.legal_name,
      companyType: user.company?.company_type,
    },
  });
}

export function resetGrafanaFaroUser() {
  if (!initialized) return;
  faro.api.resetUser();
}

export function setGrafanaFaroView(viewName, attributes = {}) {
  if (!initialized) return;
  faro.api.setView({ name: viewName }, attributes);
}

export function pushGrafanaFaroEvent(name, attributes = {}) {
  if (!initialized) return;
  faro.api.pushEvent(name, attributes);
}

export function pushGrafanaFaroError(error, context = {}) {
  if (!initialized) return;
  faro.api.pushError(error, {
    context: {
      ...context,
      currentRoute: window.location.pathname,
    },
  });
}

export function pushGrafanaFaroMeasurement(name, values, context = {}) {
  if (!initialized) return;
  faro.api.pushMeasurement({ type: name, values, context });
}
